import i18n from 'l10n';
import dhtmlx from 'dhtmlxAdapter';

export default {
    deleteDraftIconClicked: function (e) {
        var $el = $(e.currentTarget);
        var objectId = $el.data("id");
        this.deleteDraft(objectId);
    },
    deleteDraft: function (objectId) {
        var self = this;
        dhtmlx.confirm({
            type: "confirm",
            text: i18n.t("survey.confirmdeletion"),
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no"),
            callback: function (result) {
                if (!result) return;
                $.ajaxDefaultQ({
                    url: '/CampaignCloud/Message/' + objectId + '/deleteDraft',
                    type: 'POST'
                }).done(function (response) {
                    if (typeof response.message !== 'undefined') {
                        if (response.message === "successfulDeletion") {
                            self.trackingUnload = false;
                            self.collection.fetch();
                        }
                        $.Notify.show(i18n.t("message." + response.message));
                    }
                }).fail(function (response) {
                    console.error(response);
                });
            }
        });
    }
};